import { render } from "./CampaignDetail.vue?vue&type=template&id=04a5bd18&scoped=true"
import script from "./CampaignDetail.vue?vue&type=script&lang=js"
export * from "./CampaignDetail.vue?vue&type=script&lang=js"

import "../assets/css/campaignDetail.css?vue&type=style&index=0&id=04a5bd18&scoped=true&lang=css"
import "./CampaignDetail.vue?vue&type=style&index=1&id=04a5bd18&lang=scss&scoped=true"
import "./CampaignDetail.vue?vue&type=style&index=2&id=04a5bd18&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a5bd18"]])

export default __exports__